import React, { useMemo, useState } from "react";

const payoutTable = {
  1: { 1: 3 },
  2: { 2: 12 },
  3: { 2: 2, 3: 40 },
  4: { 2: 1, 3: 5, 4: 120 },
  5: { 3: 3, 4: 15, 5: 300 },
  6: { 3: 2, 4: 8, 5: 80, 6: 800 },
  7: { 3: 1, 4: 5, 5: 25, 6: 200, 7: 1500 },
  8: { 4: 5, 5: 15, 6: 80, 7: 500, 8: 3000 },
  9: { 4: 2, 5: 10, 6: 40, 7: 200, 8: 1200, 9: 5000 },
  10: { 5: 5, 6: 25, 7: 100, 8: 500, 9: 2000, 10: 10000 },
};

const ticketsData = [
  {
    id: "83429499",
    player: "Samuel",
    round: "#186",
    numbers: [30, 60, 38, 66, 67, 26, 25],
    hits: [30, 60, 67],
    bet: 10,
    status: "won",
    time: "09/05 15:05",
  },
  {
    id: "8b6ddf4f",
    player: "Samuel",
    round: "#127",
    numbers: [53, 56, 44, 23, 32, 57, 27],
    hits: [53, 27],
    bet: 10,
    status: "lost",
    time: "08/05 16:48",
  },
  {
    id: "1bdf5af4",
    player: "Samuel",
    round: "#127",
    numbers: [74],
    hits: [],
    bet: 10,
    status: "lost",
    time: "08/05 16:47",
  },
  {
    id: "bfca6c3e",
    player: "Samuel",
    round: "#93",
    numbers: [31, 32, 33, 36, 53],
    hits: [31, 36],
    bet: 10,
    status: "won",
    time: "08/05 12:57",
  },
];

const rounds = [
  {
    round: "#374",
    time: "11/05 12:20",
    numbers: [5, 51, 59, 56, 68, 29, 16, 48, 23, 78],
  },
  {
    round: "#373",
    time: "11/05 12:18",
    numbers: [56, 80, 58, 76, 35, 6, 5, 22, 12, 66],
  },
  {
    round: "#372",
    time: "11/05 12:16",
    numbers: [36, 54, 42, 30, 50, 7, 29, 24, 12, 8],
  },
];

export default function FastKenoAdmin() {
  const [tab, setTab] = useState(0);
  const [roundId, setRoundId] = useState("");
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("");

  const tickets = useMemo(() => {
    return ticketsData.map((ticket) => {
      const picks = ticket.numbers.length;
      const matches = ticket.hits.length;
      const multiplier = payoutTable[picks]?.[matches] || 0;
      const win = multiplier * ticket.bet;

      return { ...ticket, matches, multiplier, win };
    });
  }, []);

  const filteredTickets = tickets.filter((ticket) => {
    const roundMatch = roundId ? ticket.round.includes(roundId) : true;
    const userMatch = userId
      ? ticket.player.toLowerCase().includes(userId.toLowerCase())
      : true;
    const statusMatch = status ? ticket.status === status : true;

    return roundMatch && userMatch && statusMatch;
  });

  const [config, setConfig] = useState({
    bettingTimer: 60,
    resultsDisplay: 8,
    minBet: 1,
    maxBet: 10000,
    drawDelay: 2500,
    ballsPerRound: 20,
    maxTickets: 0,
  });

  const handleConfigChange = (key, value) => {
    setConfig((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const saveConfig = () => {
    console.log("Saved config:", config);
  };

  return (
    <div className="min-h-screen bg-slate-950 p-6 text-white">
      <div className="max-w-[1600px] mx-auto bg-slate-900 rounded-3xl border border-white/10 overflow-hidden">
        {/* HEADER */}
        <div className="flex flex-wrap justify-between items-center gap-4 p-6 border-b border-white/10">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center text-2xl">
              🎰
            </div>

            <div>
              <h1 className="text-3xl font-bold">Fast Keno Admin</h1>
              <p className="text-sm text-white/60">
                Real-time game analytics & configuration
              </p>
            </div>
          </div>

          <div className="flex gap-3 flex-wrap">
            <StatCard title="Tickets" value="5" />
            <StatCard title="Won" value="2" />
            <StatCard title="Revenue" value="$40" />
          </div>
        </div>

        {/* TABS */}
        <div className="px-6 pt-4">
          <div className="flex gap-2 overflow-x-auto">
            {["Overview", "Rounds", "Tickets", "Config"].map((label, index) => (
              <button
                key={label}
                onClick={() => setTab(index)}
                className={`px-4 py-3 rounded-xl font-medium transition whitespace-nowrap ${
                  tab === index
                    ? "bg-blue-600 text-white"
                    : "text-white/70 hover:bg-white/10"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        {/* OVERVIEW TAB */}
        {tab === 0 && (
          <div className="p-6 space-y-6">
            {/* DATE FILTER */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <input
                type="date"
                className="bg-slate-800 border border-white/10 rounded-xl p-2 text-white"
              />
              <input
                type="date"
                className="bg-slate-800 border border-white/10 rounded-xl p-2 text-white"
              />
              <div className="flex gap-2">
                <button className="flex-1 bg-blue-600 hover:bg-blue-700 rounded-xl font-bold transition">
                  Apply
                </button>
                <button className="flex-1 bg-slate-700 hover:bg-slate-600 rounded-xl font-bold transition">
                  Clear
                </button>
              </div>
            </div>

            {/* STATS GRID */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <OverviewCard title="Total Rounds" value="352" />
              <OverviewCard title="Total Wagered" value="50 ETB" />
              <OverviewCard title="Total Paid Out" value="30 ETB" />
              <OverviewCard title="House Profit" value="20 ETB" />

              <OverviewCard title="House Edge" value="40%" />
              <OverviewCard title="Unique Players" value="1" />
              <OverviewCard title="Win Rate" value="40%" />
              <OverviewCard title="Biggest Win" value="20 ETB" />

              <OverviewCard title="Today Wagered" value="0 ETB" />
              <OverviewCard title="Today Paid Out" value="0 ETB" />
              <OverviewCard title="Today Profit" value="0 ETB" />
              <OverviewCard title="Today Tickets" value="0" />
              <OverviewCard title="Today Players" value="0" />
              <OverviewCard title="Avg Bet" value="10 ETB" />
            </div>
          </div>
        )}
        {tab === 1 && (
          <>
            <div className="space-y-4">
              {/* Filter Section */}
              <div className="flex flex-wrap items-end gap-3">
                <div className="flex flex-col">
                  <label className="text-sm mb-1">From</label>
                  <input
                    type="date"
                    className="bg-slate-800 border border-white/10 rounded-xl px-3 py-2"
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-sm mb-1">To</label>
                  <input
                    type="date"
                    className="bg-slate-800 border border-white/10 rounded-xl px-3 py-2"
                  />
                </div>

                <button className="bg-blue-600 px-4 py-2 rounded-xl font-bold">
                  Filter
                </button>

                <button className="border border-blue-600 text-blue-400 px-4 py-2 rounded-xl">
                  Clear
                </button>

                <p className="text-sm ml-auto">362 rounds</p>
              </div>

              {/* Table */}
              <div className="overflow-x-auto border border-white/10 rounded-2xl">
                <table className="min-w-full text-sm">
                  <thead className="bg-slate-800">
                    <tr>
                      <th className="p-3 text-left">Round</th>
                      <th className="p-3 text-left">Time</th>
                      <th className="p-3 text-left">Draw (first 10)</th>
                      <th className="p-3 text-right">Tickets</th>
                      <th className="p-3 text-right">Wagered</th>
                      <th className="p-3 text-right">Paid Out</th>
                      <th className="p-3 text-right">Profit</th>
                    </tr>
                  </thead>

                  <tbody>
                    {rounds.map((item, index) => (
                      <tr
                        key={index}
                        className="border-t border-white/5 hover:bg-white/5"
                      >
                        <td className="p-3">{item.round}</td>
                        <td className="p-3">{item.time}</td>

                        <td className="p-3">
                          <div className="flex flex-wrap gap-1">
                            {item.numbers.map((num) => (
                              <div
                                key={num}
                                className="w-8 h-8 flex items-center justify-center bg-slate-700 rounded-lg text-xs"
                              >
                                {num}
                              </div>
                            ))}
                            <span className="text-xs ml-2">+10</span>
                          </div>
                        </td>

                        <td className="p-3 text-right">0</td>
                        <td className="p-3 text-right">0</td>
                        <td className="p-3 text-right">0</td>
                        <td className="p-3 text-right">0</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex justify-between items-center">
                <button className="px-3 py-1 border rounded disabled:opacity-50">
                  Prev
                </button>
                <p>Page 1 / 19</p>
                <button className="px-3 py-1 border rounded">Next</button>
              </div>
            </div>
          </>
        )}
        {tab === 2 && (
          <>
            {/* FILTERS */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-6">
              <input
                className="bg-slate-800 border border-white/10 rounded-xl p-2 text-white"
                placeholder="Round ID"
                value={roundId}
                onChange={(e) => setRoundId(e.target.value)}
              />

              <input
                className="bg-slate-800 border border-white/10 rounded-xl p-2 text-white"
                placeholder="User ID"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
              />

              <select
                className="bg-slate-800 border border-white/10 rounded-xl p-2 text-white"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">All</option>
                <option value="won">Won</option>
                <option value="lost">Lost</option>
              </select>

              <button className="bg-blue-600 hover:bg-blue-700 rounded-xl font-bold transition">
                Search
              </button>
            </div>

            {/* TABLE */}
            <div className="p-6">
              <div className="overflow-x-auto rounded-2xl border border-white/10">
                <table className="min-w-full text-sm">
                  <thead className="bg-slate-800">
                    <tr>
                      {[
                        "Ticket ID",
                        "Player",
                        "Round",
                        "Numbers",
                        "Bet",
                        "Matches",
                        "Multiplier",
                        "Win",
                        "Status",
                        "Time",
                      ].map((head) => (
                        <th key={head} className="p-3 text-left font-bold">
                          {head}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {filteredTickets.map((ticket) => (
                      <tr
                        key={ticket.id}
                        className="border-t border-white/5 hover:bg-white/5"
                      >
                        <td className="p-3">{ticket.id}...</td>
                        <td className="p-3">{ticket.player}</td>
                        <td className="p-3">{ticket.round}</td>

                        <td className="p-3 flex flex-wrap gap-1 max-w-xs">
                          {ticket.numbers.map((num) => {
                            const hit = ticket.hits.includes(num);

                            return (
                              <div
                                key={num}
                                className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-xs border ${
                                  hit
                                    ? "bg-green-500 border-green-400"
                                    : "bg-slate-800 border-white/10"
                                }`}
                              >
                                {num}
                              </div>
                            );
                          })}
                        </td>

                        <td className="p-3">${ticket.bet}</td>
                        <td className="p-3">{ticket.matches}</td>
                        <td className="p-3">
                          {ticket.multiplier ? `x${ticket.multiplier}` : "—"}
                        </td>

                        <td
                          className={`p-3 font-bold ${
                            ticket.win > 0 ? "text-green-400" : "text-red-400"
                          }`}
                        >
                          {ticket.win > 0 ? `+$${ticket.win}` : "—"}
                        </td>

                        <td className="p-3">
                          <span
                            className={`px-2 py-1 rounded-lg text-xs font-bold ${
                              ticket.status === "won"
                                ? "bg-green-600"
                                : "bg-red-600"
                            }`}
                          >
                            {ticket.status}
                          </span>
                        </td>

                        <td className="p-3">{ticket.time}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
        {tab === 3 && (
          <div className="p-6 space-y-6">
            {/* TITLE */}
            <div>
              <h2 className="text-2xl font-bold">Keno Game Configuration</h2>
            </div>

            {/* GRID */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Betting Timer */}
              <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
                <label className="text-sm text-white/70">
                  Betting Timer (seconds)
                </label>
                <input
                  type="number"
                  value={config.bettingTimer}
                  onChange={(e) =>
                    handleConfigChange("bettingTimer", Number(e.target.value))
                  }
                  className="w-full mt-2 bg-slate-900 border border-white/10 rounded-xl p-2 text-white"
                />
                <p className="text-xs text-white/50 mt-2">
                  How long players can bet each round
                </p>
              </div>

              {/* Results Display */}
              <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
                <label className="text-sm text-white/70">
                  Results Display (seconds)
                </label>
                <input
                  type="number"
                  value={config.resultsDisplay}
                  onChange={(e) =>
                    handleConfigChange("resultsDisplay", Number(e.target.value))
                  }
                  className="w-full mt-2 bg-slate-900 border border-white/10 rounded-xl p-2 text-white"
                />
                <p className="text-xs text-white/50 mt-2">
                  How long to show results before next round
                </p>
              </div>

              {/* Minimum Bet */}
              <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
                <label className="text-sm text-white/70">
                  Minimum Bet (ETB)
                </label>
                <input
                  type="number"
                  value={config.minBet}
                  onChange={(e) =>
                    handleConfigChange("minBet", Number(e.target.value))
                  }
                  className="w-full mt-2 bg-slate-900 border border-white/10 rounded-xl p-2 text-white"
                />
              </div>

              {/* Maximum Bet */}
              <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
                <label className="text-sm text-white/70">
                  Maximum Bet (ETB)
                </label>
                <input
                  type="number"
                  value={config.maxBet}
                  onChange={(e) =>
                    handleConfigChange("maxBet", Number(e.target.value))
                  }
                  className="w-full mt-2 bg-slate-900 border border-white/10 rounded-xl p-2 text-white"
                />
              </div>

              {/* Ball Draw Delay */}
              <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
                <label className="text-sm text-white/70">
                  Ball Draw Delay (ms)
                </label>
                <input
                  type="number"
                  value={config.drawDelay}
                  onChange={(e) =>
                    handleConfigChange("drawDelay", Number(e.target.value))
                  }
                  className="w-full mt-2 bg-slate-900 border border-white/10 rounded-xl p-2 text-white"
                />
                <p className="text-xs text-white/50 mt-2">
                  Delay between each ball drawn
                </p>
              </div>

              {/* Balls per Round */}
              <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
                <label className="text-sm text-white/70">
                  Balls to Draw per Round
                </label>
                <input
                  type="number"
                  value={config.ballsPerRound}
                  onChange={(e) =>
                    handleConfigChange("ballsPerRound", Number(e.target.value))
                  }
                  className="w-full mt-2 bg-slate-900 border border-white/10 rounded-xl p-2 text-white"
                />
                <p className="text-xs text-white/50 mt-2">
                  Typically 20 for standard keno
                </p>
              </div>

              {/* Max Tickets */}
              <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
                <label className="text-sm text-white/70">
                  Max Tickets per Player (0 = unlimited)
                </label>
                <input
                  type="number"
                  value={config.maxTickets}
                  onChange={(e) =>
                    handleConfigChange("maxTickets", Number(e.target.value))
                  }
                  className="w-full mt-2 bg-slate-900 border border-white/10 rounded-xl p-2 text-white"
                />
              </div>
            </div>

            {/* DIVIDER */}
            <div className="border-t border-white/10 pt-4" />

            {/* SAVE BUTTON */}
            <button
              onClick={saveConfig}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 px-5 py-3 rounded-xl font-bold transition"
            >
              ⚙️ Save Configuration
            </button>

            {/* NOTE */}
            <p className="text-xs text-white/50">
              ⚠️ Changes apply to the NEXT round. The current round uses
              previous settings.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

function StatCard({ title, value }) {
  return (
    <div className="min-w-[120px] p-3 bg-slate-800 border border-white/10 rounded-2xl">
      <p className="text-xs text-white/60">{title}</p>
      <p className="text-xl font-bold">{value}</p>
    </div>
  );
}

function OverviewCard({ title, value }) {
  return (
    <div className="bg-slate-800 border border-white/10 rounded-2xl p-4">
      <p className="text-xs text-white/60">{title}</p>
      <p className="text-xl font-bold mt-1">{value}</p>
    </div>
  );
}
